import { capitalizeFirstLetter } from "helpers";
import { Language } from "libs/localization";
import moment from "moment";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import "moment/locale/fr";

moment.updateLocale("en", {
  week: {
    dow: 1
  }
});

moment.updateLocale("fr", {
  months: moment.localeData("fr").months().map(capitalizeFirstLetter),
  weekdays: moment.localeData("fr").weekdays().map(capitalizeFirstLetter),
  weekdaysShort: moment
    .localeData("fr")
    .weekdaysShort()
    .map((day) => capitalizeFirstLetter(day).slice(0, day.length - 1)),
  monthsShort: moment
    .localeData("fr")
    .monthsShort()
    .map((month) => capitalizeFirstLetter(month.slice(0, month.length - 1)))
});

const useLanguage = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = async (lang: Language) => {
    try {
      await i18n.changeLanguage(lang);
    } catch {
      toast.error(t("Something went wrong with language change"));
    }
  };

  const switchLanguage = async () => {
    if (i18n.language === "en") await i18n.changeLanguage("fr");
    else await i18n.changeLanguage("en");
  };

  return {
    currentLanguage: i18n.language,
    changeLanguage,
    switchLanguage,
    isEnglishActive: i18n.language === "en",
    isFrenchActive: i18n.language === "fr"
  };
};

export default useLanguage;
